'use client'

import { useBreakpoints } from '@/components/providers/BreakpointProvider'
import { type FloatingPopoverType } from '@/defs/floating'

import { FloatingModalTrigger } from '../common/FloatingModalTrigger/FloatingModalTrigger'

import { FloatingPopoverDesktop } from './FloatingPopoverDesktop/FloatingPopoverDesktop'

export const FloatingPopover = (props: FloatingPopoverType) => {
  const { isDesktop } = useBreakpoints()

  if (!props.content) return props.children

  if (!isDesktop) return <FloatingModalTrigger {...props} />

  return <FloatingPopoverDesktop {...props} />
}
